import { Badge } from '@avagency/frontend/components/ui/badge';
import { cn } from '@avagency/frontend/lib/utils';
import type { POStatus } from '../api';

type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline';

// Stable map from PO status → shadcn Badge variant + optional extra class.
// Tweak here to re-skin all badges across PurchaseOrders + PODetail in one place.
//
// Visual intent (LP-aligned):
//   draft     = outline (muted, work-in-progress)
//   sent      = secondary (in-flight, waiting on supplier)
//   confirmed = green (positive milestone — supplier confirmed)
//   received  = green (terminal success)
//   cancelled = destructive (red, negative outcome)
const VARIANT: Record<POStatus, BadgeVariant> = {
  draft: 'outline',
  sent: 'secondary',
  confirmed: 'default',
  received: 'default',
  cancelled: 'destructive',
};

// Extra Tailwind classes for statuses that need colour treatment beyond
// the default shadcn variant. Confirmed + received get the product green.
const EXTRA_CLASS: Partial<Record<POStatus, string>> = {
  confirmed: 'bg-primary/15 text-primary border-primary/30 hover:bg-primary/20',
  received:  'bg-primary/20 text-primary border-primary/35 hover:bg-primary/25',
};

export function StatusBadge({ status }: { status: POStatus }) {
  const label = status.charAt(0).toUpperCase() + status.slice(1);
  const extraClass = EXTRA_CLASS[status];

  return (
    <Badge
      variant={VARIANT[status]}
      className={cn(extraClass)}
    >
      {label}
    </Badge>
  );
}
